
function init() {

    if ($("#productCarousel")) {

        //Handles the carousel thumbnails
        $(".thumbnail.carousel-selector").click(function () {
            var imageIndex = $(this).data("image-index");
            try {
                var carousel = window.bootstrap.Carousel.getOrCreateInstance($("#productCarousel"));
                carousel.to(parseInt(imageIndex));
            } catch (e) {
                console.log("Error triggering carousel!", e);
            }
        });

        // When the carousel slides, auto update the text
        $("#productCarousel").on("slid.bs.carousel",
            function (e) {
                var id = $(".item.active").data("slide-number");
                $("#carousel-text").html($("#slide-content-" + id).html());
            });

    }

}


export default {
    init
}